// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"b7a6717b","786":"39bd774d","815":"770875a6"}[chunkId] + ".chunk.js";
};